import { Component, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';
import { FormBuilder,FormControl, Validators, FormGroup, FormGroupDirective, NgForm } from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import { Router } from '@angular/router'
import { ApiService } from '../api.service'
import { ObservablesService } from '../observables.service'
import {Observable} from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}
@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss']
})
export class UserHeaderComponent implements OnInit {
  @Output() onDataChanged: EventEmitter<any> = new EventEmitter<any>();
  dataForm:FormGroup
  unitFormStatus:boolean = true;
  h_level:any=[];
  business_id : any;
  myControl = new FormControl('');
  myControl1 = new FormControl('');
  parties:any = []
  options:any = []
  options1:any = []
  filteredOptions: Observable<string[]>;
  filteredOptions1: Observable<string[]>;
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  selectedDateRange:Date[]
  loggedUserInfo:any;
  selectedUserData:any=null
  selectedTagData:any=null
  selectedData:any = {selectedParty:null, selectedDates:null, selectedTag:null}
  users:any=[]
  treeData:any=[]
  lastUsersList:any=[]
  selectedUsers:any=[]
  passwordForm:FormGroup;
  tagForm:FormGroup;
  showPopupStatus:boolean = false
  mb_tag_status:boolean = false
  showTagPopupStatus:boolean = false
  matcher = new MyErrorStateMatcher();
  changePasswordObserver:any;
  getHeaderObserver:any;
  refreshHeaderPartyObserver:any;
  resetPartySearchObserver:any;
  profileUpdateSubscriber:any;
  tags:any=[]
  tagPopupObserver:any;
  tagPopupStatus:boolean = false
  editTagStatus:boolean = false
  tagEditId:any='';
  constructor(private router:Router, private observables:ObservablesService, private api:ApiService,private fb:FormBuilder) {
    this.maxDate.setDate(this.maxDate.getDate() - 60);
    this.bsRangeValue = [this.maxDate,this.bsValue];
    this.selectedDateRange = [this.maxDate,this.bsValue];
    this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
      // console.log("this.bsRangeValuess=",this.bsRangeValue)
    this.changePasswordObserver = this.observables.changePasswordStatus.subscribe(()=>{
      this.showPopupStatus = true
    })

    this.tagPopupObserver = this.observables.tagPopupStatus.subscribe(()=>{
      this.showTagPopupStatus = true
      this.getTags()
    })
    this.passwordForm = this.fb.group({
      old_password:['',Validators.compose([Validators.required])],
      new_password:['',Validators.compose([Validators.required])],
      confirm_password:['']
    },{validator: this.checkPasswords });

    this.tagForm = this.fb.group({
      tag_name:['',Validators.compose([Validators.required])]
    });
  }

  showTagBlock(){
    this.mb_tag_status = !this.mb_tag_status
    // this.myControl.patchValue('')
    // this.myControl1.patchValue('')
  }

  gotoDashboard(){

    this.observables.showMobileDashboardStatus.next()

  }

  getTags(){
   this.api.send("findDb",{
     table:"tags",
     conditions:[{business_id:this.loggedUserInfo.business_id}]
   }).then((result:any)=>{
     this.tags=result.data
     this.options1 = result.data;
     this.filteredOptions1 = this.myControl1.valueChanges
     .pipe(
       startWith(''),
       map(value => this._filter1(value))
     );
      // console.log("this.filteredOptions1===",this.filteredOptions1)
   })
  }
  private _filter1(value: string): string[] {
    // console.log("value==",value)

    if(value == ''){
      this.selectedTagData = null;
      this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.bsRangeValue, selectedTag:this.selectedTagData}
      this.onDataChanged.emit(this.selectedData);
    }
    if(value){

      const filterValue = value.toLowerCase();
      return this.options1.filter(option => option.tag_name.toLowerCase().includes(filterValue));
    }
  }

  onSelectionChanged1(_event: any,userData) {

    if (_event.isUserInput) {
      // console.log("selected tag=",userData)
       this.selectedTagData= userData;
       this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
       this.onDataChanged.emit(this.selectedData);
       // this.onTagChanged.emit(userData)
    }

  }



  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
   let pass = group.controls.new_password.value;
   let confirmPass = group.controls.confirm_password.value;

   return pass === confirmPass ? null : { notSame: true }
 }

 ngOnDestroy(){
   this.changePasswordObserver.unsubscribe()
   this.getHeaderObserver.unsubscribe()
   this.refreshHeaderPartyObserver.unsubscribe()
   this.resetPartySearchObserver.unsubscribe()
   this.profileUpdateSubscriber.unsubscribe()
 }


  ngOnInit() {

    this.getHeaderObserver = this.observables.getHeaderStatus.subscribe(()=>{
      // this.observables.setHeaderData.next(this.selectedData)
      this.onDataChanged.emit(this.selectedData);
    })

    // this.observables.refreshHeaderPartyStatus.subscribe((res)=>{
    //   // console.log("selected client==",res)
    //   if(res !== undefined){
    //     this.parties = []
    //     this.options = []
    //     this.getParties(res.id).then((res:any)=>{
    //       this.parties = [...this.parties,...res]
    //       this.getLoggedUserParties()
    //     })
    //   }
    // })

    this.refreshHeaderPartyObserver = this.observables.refreshHeaderPartyStatus.subscribe(()=>{
      this.parties = []
      this.getUsers()
    })

    this.resetPartySearchObserver = this.observables.resetPartySearchStatus.subscribe(()=>{
      this.myControl.patchValue('')
      this.myControl1.patchValue('')
    })

    this.profileUpdateSubscriber = this.observables.profileUpdateStatus.subscribe(()=>{
      this.api.getLoggedUserInfo().then((res:any)=>{
        // console.log("res=",res)
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];

        }else{
          this.api.logOut()
        }
      })
    })

    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.h_level = Array(this.loggedUserInfo.h_level).fill(0).map((x,i)=>i+1);
        // this.getLoggedUserParties()

        this.getUsers()
        this.getTags();
      }else{
        this.api.logOut()
      }
    })
  }

  closeModel(){
    this.showPopupStatus = false;
    this.passwordForm.reset();
  }

  getLoggedUserParties(){
    // console.log("getting parties")
    this.getParties(this.loggedUserInfo.id).then((result:any)=>{
      this.parties = [...this.parties,...result]
      this.options = this.parties;
      // console.log("options==",this.options)
      this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    })
  }


  getParties(user_id){
    return new Promise((resolve)=>{
    this.api.send("findDb",{
      table:"parties",
      conditions:[{business_id:this.loggedUserInfo.business_id, user_id:user_id}],
      order:"id DESC"
    }).then((res:any)=>{
        resolve(res.data)
    })
   })
  }

  private _filter(value: string): string[] {
    // console.log("value==",value)

    if(value == ''){
      this.selectedUserData = null;
      this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.bsRangeValue, selectedTag:this.selectedTagData}
      this.onDataChanged.emit(this.selectedData);
    }

    if(value){

      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.business_name.toLowerCase().includes(filterValue));
    }
  }

  onSelectionChanged(_event: any,userData) {

    if (_event.isUserInput) {

       this.selectedUserData= userData;
       this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
       this.onDataChanged.emit(this.selectedData);
    }

  }

  onValueChange(event){
    // console.log("this.bsRangeValue=",event)
    if(event){
      this.selectedDateRange = event;
      this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
      this.onDataChanged.emit(this.selectedData);
    }
  }

  openMenu(){
    this.observables.setMenuStatus({menuState:'in'})
  }

  getUsers(){
    this.treeData = []
    this.api.send('findDb',{
      table:'users as U',
      fields:['U.id as id','U.full_name','R.role','R.level','R.is_last_level','U.role_id','U.parent_id'],
      joins:[{
        type:"left",
        table:'roles as R',
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{'U.business_id':this.loggedUserInfo.business_id}]
    }).then((result:any)=>{
      this.users=result.data
      // console.log("users=",this.users)

      var idToNodeMap = {};
      var root = null;
      var parentNode;
      for(var i = 0; i < this.users.length; i++) {
          var datum = this.users[i];
          datum.children = [];
          idToNodeMap[datum.id] = datum;

          if(!datum.parent_id) {
              root = datum;
          } else {
              parentNode = idToNodeMap[datum.parent_id];
              parentNode.children.push(datum);
          }
      }

      this.treeData.push(root)

      this.getLoggedUserTreeData(this.treeData,this.loggedUserInfo.level,this.loggedUserInfo.id)
      // console.log("this.dataSource.data=",this.treeData);

    })
  }

  getLoggedUserTreeData(data,level,id){

    for(let i=0;i<data.length;i++){
      if(data[i].level == level && data[i].id == id){
        if(data[i].children.length > 0){

          this.getAllRecursiveUsers(data[i].children)
        }else{
          this.selectedUsers =[]
        }
        this.selectedUsers = this.lastUsersList;
        this.getLoggedUserParties()
        break;
      }else{

        if(data[i].children.length > 0 && data[i].is_last_level == 0){
          this.getLoggedUserTreeData(data[i].children,level,id)
        }
      }


    }
  }

  getAllRecursiveUsers(data){
    data.filter((item: any,i) =>{
      // console.log("item=",item)
      if(item.children.length > 0 && item.is_last_level == 0){
        this.getAllParties(item.id).then((res:any)=>{
          // this.parties.push(res)
          this.getAllRecursiveUsers(item.children)
        })

      }else if(item.children.length == 0 && item.is_last_level == 1){
        this.lastUsersList.push(item);
        this.getAllParties(item.id).then((res:any)=>{
          this.getAllRecursiveUsers(item.children)
        })
      }

      // if(i == data.length-1){
      //   this.selectedUsers = this.lastUsersList;
        // console.log("this.selectedUsers"+i+"==",this.selectedUsers)
        // console.log("this.partys==",this.parties)
        // this.options = this.parties;
        //  this.filteredOptions = this.myControl.valueChanges
        //  .pipe(
        //    startWith(''),
        //    map(value => this._filter(value))
        //  );
      //   this.getLoggedUserParties()
      // }
    })
  }

  getAllParties(user_id){
    return new Promise((resolve)=>{
    this.api.send("findDb",{
      table:"parties",
      conditions:[{business_id:this.loggedUserInfo.business_id, user_id:user_id}],
      order:"id DESC"
    }).then((res:any)=>{
      if(res.data.length > 0){
        res.data.filter((item, i)=>{

          this.parties.push(item)
          if(i == res.data.length - 1){

            resolve(true)
          }
        })
      }else{
        resolve(true)
      }
    })
   })
  }

  updatePassword(value){
    // console.log("form value=",value)
    if(confirm("Are you sure to change Password?")){

      this.api.send("findDb",{
        table:"users",
        conditions:[{password:value.old_password, business_id:this.loggedUserInfo.business_id, id:this.loggedUserInfo.id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.api.send("updateDb",{
            table:"users",
            data:{
              password:value.confirm_password
            },
            conditions:[{password:value.old_password, business_id:this.loggedUserInfo.business_id, id:this.loggedUserInfo.id}]
          }).then((updateRes:any)=>{
            if(updateRes.data.affectedRows){
              this.passwordForm.reset();
              this.observables.showToastMessage({type:0,message:"Password Updated Successfully...!"})
            }else{
              this.observables.showToastMessage({type:1,message:"Can\'t Update Password, Try again...!"})
            }
          })
        }else{
          this.observables.showToastMessage({type:1,message:"Invalid Current Password...!"})
        }
      })
    }
  }

  editTag(tag){
    this.tagEditId = tag.id;
    this.tagForm.patchValue({tag_name:tag.tag_name});
    this.editTagStatus = true;
  }
  cancelEdit(){
    this.tagEditId = '';
    this.tagForm.reset();
    this.editTagStatus = false;
  }

  closeTagModel(){
    this.showTagPopupStatus = false;
  }

  updateTag(value){
    if(confirm("Are you sure to Update Tag ?")){
      this.api.send("findDb",{
        table:'tags',
        conditions:[{tag_name:value.tag_name,business_id:this.loggedUserInfo.business_id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.observables.showToastMessage({type:1,message:"Tag Name Already Exists."})
        }else{
          this.api.send("updateDb",{
            table:'tags',
            data:{tag_name:value.tag_name},
            conditions:[{id:this.tagEditId,business_id:this.loggedUserInfo.business_id}]
          }).then((res1:any)=>{
            if(res1.data.affectedRows){
              // this.tagForm.reset()
              this.getTags()
              this.cancelEdit()
              this.observables.showToastMessage({type:0,message:"Tag Updated.."})
              this.observables.refreshTagsStatus.next()
            }else{

              this.observables.showToastMessage({type:1,message:"Can\'t update tag, Try again."})
            }
          })
        }
      })
    }
  }

  deleteTag(id){
    if(confirm("Are you sure to delete Tag ?")){

      this.api.send("deleteDb",{
        table:'tags',
        conditions:[{id:id,business_id:this.loggedUserInfo.business_id}]
      }).then((res1:any)=>{
        if(res1.data.affectedRows){
          this.getTags()
          this.observables.showToastMessage({type:0,message:"Tag Deleted.."})
          this.observables.refreshTagsStatus.next()
        }else{

          this.observables.showToastMessage({type:1,message:"Can\'t delete tag, Try again."})
        }
      })
    }
  }
  addTag(value){
    // console.log('value==',value)
    this.api.send("findDb",{
      table:'tags',
      conditions:[{tag_name:value.tag_name,business_id:this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){
        this.observables.showToastMessage({type:1,message:"Tag Name Already Exists."})
      }else{
        this.api.send("insertDb",{
          table:'tags',
          data:{tag_name:value.tag_name,business_id:this.loggedUserInfo.business_id}
        }).then((res1:any)=>{
          if(res1.data.affectedRows){
            this.tagForm.reset()
            this.getTags()
            this.observables.showToastMessage({type:0,message:"Tag Added.."})
            this.observables.refreshTagsStatus.next()
          }else{
            this.observables.showToastMessage({type:1,message:"Tag Name Already Tag Can\'t Add, Try again."})

          }
        })
      }
    })
  }



}
